import React from "react";

import { useLocation } from "@reach/router";

import { isPageWithoutMobileBottomMenu } from "@/utils/urlUtils";

import CommonHeader from "./commonHeader";
import LandingHeader from "./landingHeader";

const Header = () => {
  const { pathname } = useLocation();
  const isLanding = isPageWithoutMobileBottomMenu(pathname);

  return (isLanding ? <LandingHeader /> : <CommonHeader />);
};

export default Header;
